import { getImageComponent } from 'src/viewLayer/assets/images';
import '../index.scss';

export default ({ image }: { image: string }): JSX.Element => (
  <div className="image-container">
    { getImageComponent(image) }
  </div>
);
